import Form from './../Form.js'

export default {
  props: ['modalContent'],
  data() {
    return {
      form: new Form(this.modalContent.formClassFields),
    }
  },
  methods: {
    handleSubmit() {
      this.form[this.modalContent.submitMethod](this.modalContent.submitUrl)
      .then((model) => {
        this.$emit(this.modalContent.successEvent, model)
      })
      .catch(err => {})
    },
  },
}



// WEBPACK FOOTER //
// ./resources/js/components/cu-modal-mixin.js